import {
  ExecutiveOverviewTypes,
  ExecutiveOverviewState,
} from "../types/executiveOverviewTypes";

const initialState: ExecutiveOverviewState = {
  cmPerformance: {
    data: null,
    loading: false,
    error: null,
  },
  phicTrendFilters: {
    data: null,
    loading: false,
    error: null,
  },
  phicTrendData: {
    data: null,
    loading: false,
    error: null,
  },
};

const executiveOverviewReducer = (state = initialState, action: any): ExecutiveOverviewState => {
  switch (action.type) {
    // CM Performance - Request
    case ExecutiveOverviewTypes.GET_CM_PERFORMANCE_REQUEST:
      return {
        ...state,
        cmPerformance: {
          ...state.cmPerformance,
          loading: true,
          error: null,
        },
      };

    // CM Performance - Success
    case ExecutiveOverviewTypes.GET_CM_PERFORMANCE_SUCCESS:
      return {
        ...state,
        cmPerformance: {
          data: action.payload?.data || null,
          loading: false,
          error: null,
        },
      };

    // CM Performance - Failure
    case ExecutiveOverviewTypes.GET_CM_PERFORMANCE_FAILURE:
      return {
        ...state,
        cmPerformance: {
          data: null,
          loading: false,
          error: action.payload?.message || "Failed to retrieve CM performance data",
        },
      };

    // PHIC Trend Filters - Request
    case ExecutiveOverviewTypes.GET_PHIC_TREND_FILTERS_REQUEST:
      return {
        ...state,
        phicTrendFilters: {
          ...state.phicTrendFilters,
          loading: true,
          error: null,
        },
      };

    // PHIC Trend Filters - Success
    case ExecutiveOverviewTypes.GET_PHIC_TREND_FILTERS_SUCCESS:
      return {
        ...state,
        phicTrendFilters: {
          data: action.payload?.data || null,
          loading: false,
          error: null,
        },
      };

    // PHIC Trend Filters - Failure
    case ExecutiveOverviewTypes.GET_PHIC_TREND_FILTERS_FAILURE:
      return {
        ...state,
        phicTrendFilters: {
          ...state.phicTrendFilters,
          loading: false,
          error: action.payload?.message || "Failed to retrieve PHIC trend filter options",
        },
      };

    // PHIC Trend Data - Request
    case ExecutiveOverviewTypes.GET_PHIC_TREND_DATA_REQUEST:
      return {
        ...state,
        phicTrendData: {
          ...state.phicTrendData,
          loading: true,
          error: null,
        },
      };

    // PHIC Trend Data - Success
    case ExecutiveOverviewTypes.GET_PHIC_TREND_DATA_SUCCESS:
      return {
        ...state,
        phicTrendData: {
          data: action.payload?.data || null,
          loading: false,
          error: null,
        },
      };

    // PHIC Trend Data - Failure
    case ExecutiveOverviewTypes.GET_PHIC_TREND_DATA_FAILURE:
      return {
        ...state,
        phicTrendData: {
          ...state.phicTrendData,
          loading: false,
          error: action.payload?.message || "Failed to retrieve PHIC trend data",
        },
      };

    default:
      return state;
  }
};

export default executiveOverviewReducer;
